
<template>
  <div class="container">
    <div :class="AgentIsShow == true ? 'scrollAgent' : 'scroll'">
      <div class="flex_address"
           @click="onClickCode()">
        <div class="flex"
             style="flex: 1;">
          <span style="color: #969799;padding-top: 4px;">
            <svg class="myPropertyIcon"
                 aria-hidden="true">
              <use xlink:href="#icon-kucun"></use>
            </svg>
          </span>
          <div style="padding: 0 12px;">
            我的库存码
          </div>
        </div>
        <div>
          <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
        </div>
      </div>
      <div class="flex_address"
           v-if="userInfo.userType == 'owner'"
           @click="onProfit()">
        <div class="flex"
             style="flex: 1;">
          <span style="color: #969799;padding-top: 4px;">
            <svg class="myPropertyIcon"
                 aria-hidden="true">
              <use xlink:href="#icon-wodelirun"></use>
            </svg>
          </span>
          <div style="padding: 0 12px;">
            我的利润
          </div>
        </div>
        <div>
          <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
        </div>
      </div>

    </div>
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import {
  Search,
  AddressList,
  Toast,
  Cell,
  Panel,
  Icon,
  Tag,
  Button,
  List,
  PullRefresh,
  Overlay,
  Dialog,
  SwipeCell,
  Field,
  Notify
} from "vant";
import { mapGetters, mapActions } from "vuex";
import loading from "../../components/loading/loading";
export default {
  components: {
    [Search.name]: Search,
    [AddressList.name]: AddressList,
    [Toast.name]: Toast,
    [Cell.name]: Cell,
    [Panel.name]: Panel,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Overlay.name]: Overlay,
    [Dialog.Component.name]: Dialog.Component,
    [SwipeCell.name]: SwipeCell,
    [Field.name]: Field,
    [Notify.name]: Notify,
    loading
  },
  data () {
    return {
      isLoading: false, //loading状态
    };
  },
  computed: {
    ...mapGetters(["userInfo", "agentShow"]),
    AgentIsShow () {
      return this.agentShow == null ? false : this.agentShow.isShow;
    },

  },
  methods: {
    ...mapActions(["updateUserCartQuantity", "buyAgentStatus"]),
    // 我的库存码
    onClickCode () {
      this.$router.push({
        name: "inventoryCode"
      });
    },
    // 我的利润
    onProfit () {
      this.$router.push({
        name: "profit",
      });
    },

  },

};
</script>
<style lang="less" scoped>
@deep: ~'>>>';

.container {
  width: 100%;
  display: flex;
  flex-direction: column;
  // position: fixed;
  // height: calc(100% - 12.7vw);
  min-height: 100vh;
  width: 100%;
  // overflow-y: scroll;
  position: fixed;
  height: calc(100% - 0.7vw);
  background: #f8f8f8;

  .myPropertyIcon {
    width: 16px;
    height: 16px;
  }

  .van-overlay {
    z-index: 1000;
  }

  .scroll {
    height: calc(100% - 2.3vw);
    overflow-y: auto;
    padding-bottom: 19.4vw;
    padding-top: 12px;
  }

  .scrollAgent {
    height: calc(100% - 2.3vw);
    overflow-y: auto;

    padding-top: 12px;
  }
}
.flex_address {
  height: 14px;
  display: flex;
  align-items: center;
  background: #fff;
  padding: 16px 12px 16px;
  margin: 0 12px 8px;
  border-radius: 8px;
  justify-content: space-between;
  box-shadow: 0px 4px 8px 1px #ebebeb;
  border: 0.5px solid #e6e6e6;
  // height: 44px;
}

.name_list {
  border-radius: 8px;
  border: 1px solid #f7f7f7;
  margin-right: 8px;
  // margin-top: 8px;
}
</style>